import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import user from './user';
import analytics from './analytics';

export default combineReducers({
	router: routerReducer,
	user,
	analytics
});
